// extracted by mini-css-extract-plugin
module.exports = {"qaBanner":"styles_qaBanner__KiOVq","qaHeader":"styles_qaHeader__j0o2U","close":"styles_close__h18po"};